import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { removeUserInfo, removeUserToken, setUserInfo } from "../redux/user/action";
import Network from "../utils/Network";
import Helmet from "react-helmet";
import OneSignal from "react-onesignal";
import ErrorBoundary from "./ErrorBoundary";
import PlainNavBar from "../components/PlainNavbar";
import useToast from "../hooks/useToast";
import SettingsDialog from "../components/SettingsDialog";
import { clearScoutsData } from "../redux/scout/action";
import { clearMessages } from "../redux/chat/actions";
import { useAppTranslation } from "../i18n/useAppTranslation";

type Props = {};

const ResearchLayout = (props: Props) => {
  const userToken = useSelector((state: any) => state.userToken);
  const userInfo = useSelector((state: any) => state.userInfo);
  const [settingsDialog, setSettingsDialog] = useState(false);
  const location = useLocation();
  const axios = new Network();
  const navigate = useNavigate();
  const openToast = useToast();
  const dispatch = useDispatch();
  const { t } = useAppTranslation(["research"]);

  const handleLogout = async () => {
    dispatch(removeUserInfo());
    dispatch(removeUserToken());
    dispatch(clearMessages());
    localStorage.removeItem("user.token");
    dispatch(clearScoutsData());
    navigate("/login" + `?return=${location.pathname}`);
  };

  const getData = async () => {
    const response = await axios.CallApi({
      url: "/player",
      method: "get",
    });
    if (response.ok) {
      dispatch(setUserInfo(response.data));
      if ((response.data as any).State === 2 || (response.data as any).State === 3)
        handleLogout();
    }
  };

  useEffect(() => {
    if (!localStorage.getItem("user.token")) {
      return navigate(`/login?return=${location.pathname}`);
    }
    getData();
  }, []);

  const setUserId = async () => {
    const isSubscribed = await OneSignal.isPushNotificationsEnabled();
    if (isSubscribed) {
      await OneSignal.setExternalUserId(userInfo.ID);
    }
  };

  useEffect(() => {
    if (userInfo) setUserId();
  }, [userInfo]);

  useEffect(() => {
    if (window.location.hash?.includes("settings")) {
      setSettingsDialog(true);
    }
  }, [window.location.hash]);

  return (
    <div className="research-layout">
      <Helmet>
        <title>{t("research:title")} - Chain of Legends</title>
      </Helmet>
      <div>
        <div className="text-white research-layout-content">
          <ErrorBoundary openToast={openToast}>
            <Outlet />
          </ErrorBoundary>
        </div>
      </div>

      <SettingsDialog
        open={settingsDialog}
        onClose={() => {
          setSettingsDialog(false);
          navigate(window.location.pathname);
        }}
      />

      <style>{`
        .research-layout {
          min-height: 100vh;
          background-image: url('/assets/images/backgrounds/main-bg-1.png');
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
          background-attachment: fixed;
          background-color: #2d231d;
        }

        .research-layout-content {
          position: relative;
          z-index: 1;
        }

        @media (max-width: 768px) {
          .research-layout {
            background-size: cover;
            background-position: center top;
          }
        }
      `}</style>
    </div>
  );
};

export default ResearchLayout;
